import * as React from 'react';
import { Form, Text } from 'react-form';
import { BaseFormProps } from '../../interfaces';
import { NotificationService, LanguageDataService, SurveyVersionDataService, SurveyReportTypeDataService, CharacteristicGroupDataService, SecondaryReportDataService } from '../../services';
import { Language, SurveyVersion, SurveyReportType, CharacteristicGroup } from '../../models';
import { observer, inject } from 'mobx-react';
import { computed } from 'mobx';
import { UserStore } from '../../stores';

interface SecondaryReportFormProps extends BaseFormProps {
    notificationService: NotificationService;
    surveyVersionId: number;
    UserStore?: UserStore;
}

class SecondaryReportFormState {
    languages: Language[];
    surveyIsPublished: boolean;
    surveyReportTypes: SurveyReportType[];
    characteristicGroups: CharacteristicGroup[];
    selectedCharacteristicGroupId: number | undefined;
    toggled: boolean;
}

@inject('UserStore') @observer
export class SecondaryReportForm extends React.Component<SecondaryReportFormProps, SecondaryReportFormState> {
    private surveyVersionDataService = new SurveyVersionDataService(this.props.notificationService);
    private languageDataService = new LanguageDataService(this.props.notificationService);
    private surveyReportTypeService = new SurveyReportTypeDataService(this.props.notificationService);
    private characteristicGroupDataService = new CharacteristicGroupDataService(this.props.notificationService);
    private secondaryReportDataService = new SecondaryReportDataService(this.props.notificationService);
    
    @computed get isSuperAdmin() {
        return this.props.UserStore!.userRoleIn(['superAdmin']);
    }

    constructor(props: SecondaryReportFormProps) {
        super(props);

        this.props.defaultValues.characteristicGroupTexts = this.props.defaultValues.characteristicGroupTexts || [];
        this.props.defaultValues.surveyVersionId = this.props.defaultValues.surveyVersionId || this.props.surveyVersionId;
        this.props.defaultValues.characteristicGroupCharacteristics = this.props.defaultValues.characteristicGroupCharacteristics || [];
        this.props.defaultValues.secondaryReportOrgUsers = this.props.defaultValues.secondaryReportOrgUsers || [];
        this.state = {
            languages: [],
            surveyIsPublished: false,
            surveyReportTypes: [],
            characteristicGroups: [],
            selectedCharacteristicGroupId: undefined,
            toggled: false
        };
    }

    public componentDidMount() {

        this.secondaryReportDataService.toggleState(this.props.defaultValues.id).then((state: boolean) => {
            this.setState({
                toggled: state
            });
        });

        this.surveyVersionDataService.get(this.props.surveyVersionId).then((surveyVersion: SurveyVersion) => {
            this.setState({
                surveyIsPublished: surveyVersion.published !== null ? true : false
            });

            this.characteristicGroupDataService.getAllBySurveyVersion(surveyVersion).then((groups: CharacteristicGroup[]) => {
                if (groups && groups.length > 0) {
                    groups.sort((c1: CharacteristicGroup, c2: CharacteristicGroup) => {
                        if (c1.name > c2.name) {
                            return 1;
                        } else if (c1.name < c2.name) {
                            return -1;
                        }
                        return 0;
                    });
                    this.setState({
                        characteristicGroups: groups,
                        selectedCharacteristicGroupId: groups[0].id
                    });
                }
            });

            this.surveyReportTypeService.getBySurvey(surveyVersion.surveyID).then((surveyReportTypes: SurveyReportType[]) => {
                this.setState({
                    surveyReportTypes: surveyReportTypes
                });
            });
        });

        this.languageDataService.getAll().then((languages: Language[]) => {
            this.setState({
                languages: languages
            });
        });
    }

    public render() {

        const languageOpts: any = [];
        if (this.state.languages) {
            this.state.languages.map((x: Language) => {
                languageOpts.push({
                    label: x.name,
                    value: x.id
                });
            });
        }

        const surveyReportTypes: any = [];
        if (this.state.surveyReportTypes) {
            this.state.surveyReportTypes.map((x: SurveyReportType) => {
                surveyReportTypes.push({
                    label: x.name,
                    value: x.id
                });
            });
        }

        return (
            <Form
                defaultValues={this.props.defaultValues}
                onSubmit={submittedValues => this.props.submit(submittedValues)}
            >
                {formApi => (
                    <form onSubmit={formApi.submitForm} id="entityForm">
                        {this.state.surveyIsPublished && <div className="pva-alert">
                            <i>This survey version has already been published, so only content changes are allowed.</i>
                        </div>}
                        <fieldset>
                            <div className="form-group">
                                <label htmlFor="name">Secondary Report Name *</label>
                                <Text className="form-control" field="name" id="name" disabled={!this.isSuperAdmin} />
                            </div>

                            <div className="form-group">
                                <label htmlFor="name">Sort</label>
                                <Text className="form-control" field="sort" id="sort" />
                            </div>
                        </fieldset>
                        <fieldset>
                            <label htmlFor="name">Global Access</label>
                            <input className="checkbox" type="checkbox" checked={this.state.toggled} onChange={(e: any) => this.toggle()} />
                        </fieldset>

                        <button type="submit" className="btn btn-primary">Save</button>
                    </form>            
                )}
            </Form>
        );
    }

    private toggle() {
        this.secondaryReportDataService.toggleGlobal(this.props.defaultValues.id).then((state: boolean) => {
            this.setState({
                toggled: state
            });
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/secondaryreport/SecondaryReportForm.tsx